module.exports = __webpack_public_path__ + "img/lv3.13b4c2dc.png";